const key = {
  access_token: 'access_token',
};

export default class LocalStorage {
  // Token
  static setToken = (value: string) =>
    localStorage.setItem(key.access_token, value);

  static getToken = () => localStorage.getItem(key.access_token) ?? '';

  static clearToken = () => localStorage.removeItem(key.access_token);
}
